import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './LanguageSelector.module.css';

interface LanguageSelectorProps {
  onLanguageChange: (language: string) => void;
}

export const LanguageSelector = ({
  onLanguageChange
}: LanguageSelectorProps): ReactElement => {
  const { i18n, t } = useTranslation();

  const isNorwegian = i18n.language === 'no';
  const isEnglish = i18n.language === 'en';

  return (
    <div className={classes.container}>
      <button
        onClick={() => onLanguageChange('no')}
        className={`${classes.button} ${isNorwegian ? classes.active : ''}`}
        aria-label={t('languageSelector.switchToNorwegian')}
        aria-pressed={isNorwegian}
      >
        🇳🇴 NO
      </button>
      <button
        onClick={() => onLanguageChange('en')}
        className={`${classes.button} ${isEnglish ? classes.active : ''}`}
        aria-label={t('languageSelector.switchToEnglish')}
        aria-pressed={isEnglish}
      >
        🇬🇧 EN
      </button>
    </div>
  );
};
